import React, { useEffect, useReducer, useState, useMemo } from 'react'
import { lockedReducer } from '../../../utils/defaultReducer'
import {
    Dialog, Box, DialogActions, DialogContent, DialogTitle, Button, TextField,
    MenuItem, FormControl, InputLabel, Select,
    Tooltip
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import Loading from '../../Loading';

import {
    DataGridPro,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    gridClasses,
    LicenseInfo,
    ptBR
} from '@mui/x-data-grid-pro';

import {
    createTheme,
    ThemeProvider,
    StyledEngineProvider
} from '@mui/material/styles';

import { ptBR as corePtBR } from '@mui/material/locale';

import dayjs from 'dayjs'

import { getSession } from '../../../auth';

import api from '../../../api';

import useNotification from '../../Notification';

const theme = createTheme({
    palette: {
        primary: { main: '#21446C' },
    },
}, ptBR, corePtBR);

const translation ={
    'SUCCESS': 'Sucesso',
    'ERROR': 'Erro',
    'WAITING': 'Aguardando resultado',
    'ATENDIDA': 'Atendida',
    'NAO_ATENDIDA': 'Não atendida',
    'OCUPADA': 'Ocupada',
    'FALHA': 'Falha',
    'CONTACT TELEPHONE NOT FOUND': 'Telefone não encontrado',
    'OPPORTUNITY NOT FOUND': 'Oportunidade não encontrada'
}

const defColumns = (setState, triggers, types) => [
    { field: 'opportunity_name', headerName: 'Oportunidade', flex: 1 },
    { field: 'created_at', headerName: 'data', flex: 1, 
        valueFormatter: (params) => (params.value) ? dayjs.utc(params.value).local().format('DD/MM/YYYY HH:mm') : "" },
    { field: 'status', headerName: 'Status', flex: 1, renderCell: ({value}) => translation[value] || value },
    { field: 'comment', headerName: 'Comentário', flex: 1, renderCell: ({value}) => translation[value] || value },
    { field: 'trigger', headerName: 'Gatilho', flex: 1, renderCell: ({value}) => triggers[value] },
    { field: 'type', headerName: 'Tipo', flex: 1, renderCell: ({value}) => types[value] },
]


const initial_limit = 25

const get_rows = async (state, setState, limit = 25, page = 0, filters) => {
    setState({ loading: true })
    const enterpriseId = getSession().profile.enterprise.id
    const offset = limit * (page)

    // const urlfilters = Object.entries(filters || {}).flatMap(([key, value]) => {
    //     if (value.length === 0)
    //         return []
    //     else if (key === 'timestamp__after')
    //         return `${key}=${dayjs.utc(value).format('YYYY-MM-DD HH:mm:ss')}`
    //     else if (key === 'timestamp__before')
    //         return `${key}=${dayjs.utc(value).format('YYYY-MM-DD HH:mm:ss')}`
    //     return `${key}=${value}`
    // }).join('&')

    const res = await api.get(`api/enterprises/${enterpriseId}/journeycolumn/${state.column_id}/automation/${state.id}/history/?limit=${limit}&offset=${offset}`)
    if (res.status === 200) {
        setState({
            count: res.data.count,
            rows: res.data.results,
            loading: false,
            limit: limit,
            page: page
        })
    } else {
        setState({ loading: false })
        useNotification(
            "Ops",
            "Não foi possível recuperar os dados.",
            "danger"
        )
    }
}

const ReportJourneyAutomation = ({ column, data, handleClose, triggers, types }) => {

    const [state, setState] = useReducer(lockedReducer, {
        rows: [],
        loading: false,
        info: null,
        limit: initial_limit,
        page: 0,
        count: 0,
    })

    const [filters, setFilters] = useReducer(lockedReducer, {
       created_at__after: dayjs().subtract(1, 'month'),
       created_at__before: dayjs(),
    })

    const rowdata = {column_id: column.id, id: data.id}

    useEffect(() => {
        get_rows(rowdata, setState, initial_limit, 0, filters)
    }, [])

    return (
        <>
            <Loading loading={state.loading} />
            <Dialog
                open={true}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                className='journey-report-dialog'
                maxWidth={'md'}
            >
                <DialogTitle id="alert-dialog-slide-title" sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                        Relatório de Automação
                    </span>
                    <Box>
                        <Button sx={{ 'minWidth': '2rem', 'padding': '0' }} onClick={handleClose} >
                            <CloseIcon />
                        </Button>
                    </Box>
                </DialogTitle>
                <DialogContent >
                    <Box sx={{height: '100%'}}>
                        <StyledEngineProvider injectFirst >
                            <ThemeProvider theme={theme}>
                                <DataGridPro

                                    disableSelectionOnClick
                                    disableDensitySelector
                                    density="compact"
                                    columns={useMemo(() => defColumns(setState, triggers, types), [])}
                                    rows={state.rows}

                                    //pagination
                                    pagination
                                    rowCount={state.count}
                                    paginationMode="server"
                                    rowsPerPageOptions={[25, 50, 100]}
                                    page={state.page}

                                    onPageSizeChange={(size) => { get_rows(rowdata, setState, size, state.page, filters) }}
                                    onPageChange={(page) => { get_rows(rowdata, setState, state.limit, page, filters) }}

                                    initialState={{
                                        pagination: {
                                            pageSize: Number(initial_limit)
                                        }
                                    }}
                                />
                            </ThemeProvider>
                        </StyledEngineProvider>
                    </Box>
                </DialogContent>
            </Dialog>
        </>
    )
}

export default ReportJourneyAutomation